import { useUserProfile } from "../../features/auth/hooks/useUserProfile";

export type UnitPreference = "metric" | "imperial";

/**
 * Hook to get the user's unit preference from their profile.
 * Returns 'metric' as default if no preference is set or user is not logged in.
 */
export const useUnitPreference = (): UnitPreference => {
  const { data: userProfile } = useUserProfile();

  // Return user's preference or default to metric
  return userProfile?.unit_preference || "metric";
};
